import { FormType } from "@simplyk/common";

import { useFormV2Context } from "@/canvas/features/FormV2/contexts/FormV2Context";
import type { TicketPurchase } from "@/common/types/ticketing";
import type { RateOutput } from "@/common/types/trpc";

type MemberOnlyRate = Pick<RateOutput, "id" | "isMemberOnly" | "memberOnlyMembershipRateIds">;

const isRestrictedToMembers = (rate: MemberOnlyRate) =>
  Boolean(rate.isMemberOnly) && (rate.memberOnlyMembershipRateIds?.length ?? 0) > 0;

export const getMemberOnlyCheckoutEmail = ({
  ticketsPurchased,
  rates,
  memberEmail,
}: {
  ticketsPurchased: TicketPurchase[] | undefined;
  rates: MemberOnlyRate[];
  memberEmail: string | null;
}): string | undefined => {
  if (!memberEmail) {
    return undefined;
  }

  const hasMemberOnlyRateInCart = (ticketsPurchased ?? []).some(
    (ticket) =>
      (ticket.purchasedNumber ?? 0) > 0 &&
      rates.some((rate) => rate.id === ticket.rateId && isRestrictedToMembers(rate))
  );

  return hasMemberOnlyRateInCart ? memberEmail : undefined;
};

export const useMemberOnlyCheckoutEmail = (): string | undefined => {
  const formV2Context = useFormV2Context();
  if (formV2Context.type !== FormType.Ticketing) {
    return undefined;
  }
  return getMemberOnlyCheckoutEmail({
    ticketsPurchased: formV2Context.ticketsPurchased,
    rates: formV2Context.formObject.rates ?? [],
    memberEmail: formV2Context.membershipInfo.memberEmail,
  });
};
